import {
  AppointmentSummaryFilter,
  GetAppointmentsRequest as BaseGetAppointmentsRequest,
  GetJobSummariesRequest as BaseGetJobSummariesRequest,
  JobSummaryFilter,
} from '@eigtech/summarizer-types'
import { makeBasicQueryKeys, OmitAuthHeaders } from '@eigtech/ui-shared-api'
import { normalizeFilters } from '@eigtech/ui-shared-summarizer'

export const csrJobsBasePath = 'csr'

export const restorationBasePath = 'restoration'
export const documatorBasePath = 'documator'
export const summarizerBasePath = 'summarizer'

export type UIGetJobSummariesRequest = Omit<
  OmitAuthHeaders<BaseGetJobSummariesRequest>,
  'filter'
> & {
  filter: (Omit<JobSummaryFilter, 'value'> & { value: string })[]
}

const jobsBaseQueryKeys = makeBasicQueryKeys('jobs')
export const jobsQueryKeys = {
  ...jobsBaseQueryKeys,
  timeline: (jobId: string) => [...jobsBaseQueryKeys.detail(jobId), 'timeline'],
  filteredList: (params: UIGetJobSummariesRequest) => [...jobsBaseQueryKeys.list(), params],
  filteredAppointments: (request: GetAppointmentsRequest) => {
    const filters = normalizeFilters({ filters: request.filter })
    return [...jobsQueryKeys.all(), 'appointments', { ...request, filter: filters }]
  },
}

export type GetAppointmentFilter = {
  field: AppointmentSummaryFilter['field']
  operator?: AppointmentSummaryFilter['operator']
  value: string
}

export type GetAppointmentsRequest = Omit<OmitAuthHeaders<BaseGetAppointmentsRequest>, 'filter'> & {
  filter: GetAppointmentFilter[]
}

export type AppointmentsQueryKey = (string | GetAppointmentsRequest)[]
